package com.milta.core.localization.translations.it

import com.milta.core.localization.PackageLabelScanStrings

internal val PackageLabelScan = PackageLabelScanStrings(
    scanTitle = "Scansiona un'etichetta",
    analysingTitle = "Lettura dell'etichetta…",
    analysingSubtitle = "Stiamo cercando il nome, l'indirizzo e il numero di telefono del destinatario. Bastano pochi secondi.",
    reviewTitle = "Conferma la consegna",
    deliveryDetectedLabel = "Consegna rilevata",
    allReadableLabel = "Tutto leggibile",
    fieldToCompleteSingularSuffix = "campo da completare",
    fieldToCompletePluralSuffix = "campi da completare",
    recipientNotDetectedValue = "Non rilevato",
    addressNotDetectedValue = "Non rilevato",
    phoneNotDetectedValue = "Non rilevato",
    fieldRequiredWarning = "Campo obbligatorio per aggiungere la consegna",
    recipientCorrectionPlaceholder = "Inserisci il destinatario…",
    addressCorrectionPlaceholder = "Inserisci l'indirizzo…",
    unreadableTitle = "Etichetta illeggibile.",
    unreadableMessage = "Scatta una nuova foto inquadrata sull'etichetta, ben illuminata e senza riflessi.",
    maxAttemptsMessage = "Completa questa consegna manualmente, oppure riavvia la scansione con una nuova foto.",
)
